<template>
  <div>
    <ProductCartView></ProductCartView>
    <div class="battery-store__nav-row h-center-align">
      <button class="btn btn-primary" @click.prevent="addProducts">Add Additional Products</button>
    </div>
    <div class="css-grid battery-order-form__row battery-order-form__row--header">
      <div></div>
      <div class="battery-order-view__cell battery-order-view__cell--header">Shipping Info</div>
      <div></div>
    </div>
    <div class="panel">
      <div class="css-grid battery-order-form__row">
        <div></div>
        <div>
          <p class="h-italic-text h-center-align">All fields with * are required.</p>
          <div class="form__item--row">
            <StoreConnectedInput :store="store" :action="action" sub-prop="company" name="shippingInfo" callback="batteryStore/touchLocationInfo" placeholder="Company Name *"></StoreConnectedInput>
          </div>
        </div>
        <div></div>
      </div>
      <div class="css-grid battery-order-form__row">
        <div></div>
        <div>
          <div class="form__item--row">
            <StoreConnectedSelect :store="store" name="selectedShippingLocationID" :options="locations" options-value="id" options-label="address_label" callback="batteryStore/setLocationInfo" placeholder="Select Location *"></StoreConnectedSelect>
          </div>
        </div>
        <div></div>
      </div>
      <div class="css-grid battery-order-form__row">
        <div></div>
        <div>
          <div class="grid__col--6">
            <div class="form__item--row">
              <StoreConnectedInput :store="store" :action="action" sub-prop="first_name" name="shippingInfo" callback="batteryStore/touchLocationInfo" placeholder="First Name *"></StoreConnectedInput>
            </div>
          </div>
          <div class="grid__col--6">
            <div class="form__item--row">
              <StoreConnectedInput :store="store" :action="action" sub-prop="last_name" name="shippingInfo" callback="batteryStore/touchLocationInfo" placeholder="Last Name *"></StoreConnectedInput>
            </div>
          </div>
        </div>
        <div></div>
      </div>
      <div class="css-grid battery-order-form__row">
        <div></div>
        <div>
          <div class="grid__col--6">
            <div class="form__item--row">
              <StoreConnectedInput :store="store" :action="action" sub-prop="email" name="shippingInfo" callback="batteryStore/touchLocationInfo" placeholder="Email *"></StoreConnectedInput>
            </div>
          </div>
          <div class="grid__col--6">
            <div class="form__item--row">
              <StoreConnectedInput :store="store" :action="action" sub-prop="phone" name="shippingInfo" callback="batteryStore/touchLocationInfo" placeholder="Telephone *"></StoreConnectedInput>
            </div>
          </div>
        </div>
        <div></div>
      </div>
      <div class="css-grid battery-order-form__row">
        <div></div>
        <div>
          <div class="grid__col--8">
            <div class="form__item--row">
              <StoreConnectedInput :store="store" :action="action" sub-prop="street" name="shippingInfo" callback="batteryStore/touchLocationInfo" placeholder="Street *"></StoreConnectedInput>
            </div>
          </div>
          <div class="grid__col--4">
            <div class="form__item--row">
              <StoreConnectedInput :store="store" :action="action" sub-prop="street_2" name="shippingInfo" placeholder="Street 2"></StoreConnectedInput>
            </div>
          </div>
        </div>
        <div></div>
      </div>
      <div class="css-grid battery-order-form__row">
        <div></div>
        <div>
          <div class="grid__col--6">
            <div class="form__item--row">
              <StoreConnectedInput :store="store" :action="action" sub-prop="city" name="shippingInfo" callback="batteryStore/touchLocationInfo" placeholder="City *"></StoreConnectedInput>
            </div>
          </div>
          <div class="grid__col--3">
            <div class="form__item--row">
              <StoreConnectedSelect :store="store" :action="action" sub-prop="state" name="shippingInfo" callback="batteryStore/touchLocationInfo" :options="states" placeholder="State *"></StoreConnectedSelect>
            </div>
          </div>
          <div class="grid__col--3">
            <div class="form__item--row">
              <StoreConnectedInput :store="store" :action="action" sub-prop="zip" name="shippingInfo" callback="batteryStore/touchLocationInfo" placeholder="Zip Code *"></StoreConnectedInput>
            </div>
          </div>
        </div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import ProductCartView from './products/ProductCartView.vue';
  import StoreConnectedSelect from '../form-items/StoreConnectedSelect.vue';
  import StoreConnectedInput from '../form-items/StoreConnectedInput.vue';

  export default {
    name: 'ShippingView',
    components: {
      ProductCartView,
      StoreConnectedSelect,
      StoreConnectedInput,
    },
    data() {
      return {
        store: 'batteryStore',
        action: 'setObjectProperty',
      };
    },
    mounted() {
      this.$store.dispatch('batteryStore/setProperty', { key: 'shippingInfo', value: {
          company: this.$store.getters['auth/user']['member']['name'],
          first_name: this.$store.getters['auth/user']['userInfo']['first_name'],
          last_name: this.$store.getters['auth/user']['userInfo']['last_name'],
          email: this.$store.getters['auth/user']['userInfo']['email'],
        }})
    },
    computed: {
      ...mapGetters('batteryStore', ['locations', 'states']),
    },
    methods: {
      nextStep() {
        this.$store.dispatch('batteryStore/setProperty', { key: 'currentSection', value: 'paymentInfo'});
      },
      addProducts() {
        this.$store.dispatch('batteryStore/setProperty', { key: 'currentSection', value: 'addItems'});
      }
    },
  }
</script>
